// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { castToFloat } from 'helpers/reduxFormFunctions'
import { ProjectStatusIdEnum } from 'config/enums'

const makeProjectManagementFormQuery = formValues => {
  const {
    createUserId,
    projectName,
    projectStatusId,
  } = formValues

  // we're either are looking for Finalized projects,
  // or we are NOT looking for Finalized projects!
  const projectStatus = (
    castToFloat(projectStatusId) === ProjectStatusIdEnum.FINALIZED
      ? 'EQ'
      : 'NOT'
  )

  const search = [{
    // user is a required value for this form. No need for null check
    field: 'createUserId',
    value: createUserId.userId,
    operator: 'EQ',
  }, {
    // projectStatus is a radio button and will always have a value.
    field: 'projectStatus',
    value: 'Finalized',
    operator: projectStatus,
  }]

  // add the project name to the search if they've defined one.
  if (projectName) {
    search.push({
      field: 'projectName',
      value: projectName,
      operator: 'LIKE',
    })
  }

  return {
    field: 'search',
    value: [search],
  }
}

export default makeProjectManagementFormQuery
